import {ChangeDetectionStrategy, Component, effect, HostListener, inject, OnInit} from '@angular/core';
import {TranslatePipe, TranslateService} from "@ngx-translate/core";
import {NavigationComponent} from "../header3/navigation.component";
import {authStore} from "../../core/service/auth/auth.store";
import {RouterLink} from "@angular/router";
import {CustomTranslateService} from "../../core/service/custom-translate.service";

@Component({
    selector: 'app-header',
    imports: [
        TranslatePipe,
        NavigationComponent,
        RouterLink
    ],
    templateUrl: './header.component.html',
    styleUrl: './header.component.scss',
    standalone: true,
    changeDetection : ChangeDetectionStrategy.OnPush
})
export class HeaderComponent {
    protected readonly auth = inject(authStore);
    isTopBarHidden = false;

    // Arvo, jonka jälkeen yläosa liukuu pois
    private SCROLL_THRESHOLD = 1;

    protected readonly translateService = inject(CustomTranslateService);

    protected readonly currentLanguage = this.translateService.current;

    protected aludoMenuVisible: boolean = false;

    @HostListener('window:scroll', [])
    onWindowScroll(): void {
        const currentScroll = window.scrollY;

        this.isTopBarHidden = currentScroll > this.SCROLL_THRESHOLD;
    }

    currentLocale() {
        const locale = this.translateService.currentLang;
        return locale;
    }
}
